import { render } from "./FiscalizacaoCompeticoes.vue?vue&type=template&id=a62c402a"
import script from "./FiscalizacaoCompeticoes.vue?vue&type=script&lang=js"
export * from "./FiscalizacaoCompeticoes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__